import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { PermissionNode } from './models/permission-node.model';
import { PermissionLevel } from './models/permission-level.type';

export interface PermissionOverride {
  id: number;
  profilId: number;
  nodeId: number;
  level: PermissionLevel;
}

export interface RoleGrantItem {
  nodeId: number;
  level: PermissionLevel;
}

export interface ProfilRoleGrants {
  roleId: number | null;
  grants: RoleGrantItem[];
}

export interface OverrideItem {
  nodeId: number;
  level: PermissionLevel;
}

@Injectable({ providedIn: 'root' })
export class PermissionsApiService {
  constructor(private readonly http: HttpClient) {}

  getNodes(): Observable<PermissionNode[]> {
    return this.http.get<PermissionNode[]>('/permission-nodes');
  }

  getProfilOverrides(profilId: number): Observable<PermissionOverride[]> {
    return this.http.get<PermissionOverride[]>('/permission-profil-overrides', {
      params: { profilId: String(profilId) },
    });
  }

  /** Nadania roli profilu (resolver Eldorado liczy profil > rola > rodzic). Tylko odczyt. */
  getProfilRoleGrants(profilId: number): Observable<ProfilRoleGrants> {
    return this.http.get<ProfilRoleGrants>('/permission-profil-overrides/role-grants', {
      params: { profilId: String(profilId) },
    });
  }

  setProfilOverrides(profilId: number, items: OverrideItem[]): Observable<PermissionOverride[]> {
    return this.http.put<PermissionOverride[]>('/permission-profil-overrides', items, {
      params: { profilId: String(profilId) },
    });
  }

  getResolved(profilId: number): Observable<Record<string, PermissionLevel>> {
    return this.http.get<Record<string, PermissionLevel>>('/permissions/resolved', {
      params: { profilId: String(profilId) },
    });
  }

  getProfilsWithAccess(nodeId: number, includeNone = false): Observable<ProfilWithAccess[]> {
    return this.http.get<ProfilWithAccess[]>(`/permission-nodes/${nodeId}/profiles`, includeNone ? { params: { all: '1' } } : {});
  }

  /**
   * Poziom profilu na wezle. Na zakladce backend rozlewa go na wszystkie jej
   * pozycje (jak przelacznik zakladki w karcie profilu). Zwraca swieza liste (z 'none').
   */
  setNodeAccess(nodeId: number, profilId: number, level: PermissionLevel): Observable<ProfilWithAccess[]> {
    return this.http.put<ProfilWithAccess[]>(`/permission-nodes/${nodeId}/profiles/${profilId}`, { level });
  }
}

export interface ProfilWithAccess {
  profilId: number;
  login: string;
  imie: string;
  nazwisko: string;
  level: PermissionLevel;
  source: 'override' | 'none' | 'protected';
  resolvedFrom: string | null;
  inherited: boolean;
}
